import * as actionTypes from '../../actions/action-types.js'
const initialState = {
    lastFetch: 0,
    loading: false,
}
const sensorType = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FD_SENTYP_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: action.data,
            }
        case actionTypes.FD_SENTYP_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.FD_SENTYP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_SENTYP_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default sensorType
